import _regeneratorRuntime from "/home/ubuntu/drvakilwebapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/drvakilwebapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/ubuntu/drvakilwebapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/ubuntu/drvakilwebapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import firebase from '@firebase/app-compat';
import { Component } from '@firebase/component';
import { getToken as _getToken, deleteToken as _deleteToken, onMessage as _onMessage } from '@firebase/messaging';
import { isIndexedDBAvailable, areCookiesEnabled } from '@firebase/util';
import { onBackgroundMessage as _onBackgroundMessage } from '@firebase/messaging/sw';
var name = "@firebase/messaging-compat";
var version = "0.1.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function isSupported() {
  if (self && 'ServiceWorkerGlobalScope' in self) {
    // Running in ServiceWorker context
    return isSwSupported();
  } else {
    // Assume we are in the window context.
    return isWindowSupported();
  }
}
/**
 * Checks to see if the required APIs exist.
 */


function isWindowSupported() {
  return typeof window !== 'undefined' && isIndexedDBAvailable() && areCookiesEnabled() && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window && 'fetch' in window && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
}
/**
 * Checks to see if the required APIs exist within SW Context.
 */


function isSwSupported() {
  return isIndexedDBAvailable() && 'PushManager' in self && 'Notification' in self && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
}

var MessagingCompatImpl =
/*#__PURE__*/
function () {
  function MessagingCompatImpl(app, _delegate) {
    _classCallCheck(this, MessagingCompatImpl);

    this.app = app;
    this._delegate = _delegate;
    this.app = app;
    this._delegate = _delegate;
  }

  _createClass(MessagingCompatImpl, [{
    key: "getToken",
    value: function () {
      var _getToken2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(options) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _getToken(this._delegate, options));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getToken(_x) {
        return _getToken2.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "deleteToken",
    value: function () {
      var _deleteToken2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _deleteToken(this._delegate));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteToken() {
        return _deleteToken2.apply(this, arguments);
      }

      return deleteToken;
    }()
  }, {
    key: "onMessage",
    value: function onMessage(nextOrObserver) {
      return _onMessage(this._delegate, nextOrObserver);
    }
  }, {
    key: "onBackgroundMessage",
    value: function onBackgroundMessage(nextOrObserver) {
      return _onBackgroundMessage(this._delegate, nextOrObserver);
    }
  }]);

  return MessagingCompatImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var messagingCompatFactory = function messagingCompatFactory(container) {
  if (self && 'ServiceWorkerGlobalScope' in self) {
    // in sw
    return new MessagingCompatImpl(container.getProvider('app-compat').getImmediate(), container.getProvider('messaging-sw').getImmediate());
  } else {
    // in window
    return new MessagingCompatImpl(container.getProvider('app-compat').getImmediate(), container.getProvider('messaging').getImmediate());
  }
};

var NAMESPACE_EXPORTS = {
  isSupported: isSupported
};

function registerMessagingCompat() {
  firebase.INTERNAL.registerComponent(new Component('messaging-compat', messagingCompatFactory, "PUBLIC"
  /* PUBLIC */
  ).setServiceProps(NAMESPACE_EXPORTS));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


registerMessagingCompat();
firebase.registerVersion(name, version);